import { render, staticRenderFns } from "./AppPriorityTag.vue?vue&type=template&id=238b0e94&scoped=true&"
import script from "./AppPriorityTag.vue?vue&type=script&lang=js&"
export * from "./AppPriorityTag.vue?vue&type=script&lang=js&"
import style0 from "./AppPriorityTag.vue?vue&type=style&index=0&id=238b0e94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238b0e94",
  null
  
)

export default component.exports